import { render } from "./SimpleLoader.vue?vue&type=template&id=2a090352&scoped=true"
const script = {}

import "./SimpleLoader.vue?vue&type=style&index=0&id=2a090352&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a090352"]])

export default __exports__